var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01B2E46B-D4AE-4053-BCBE-8EA80DDC5928") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-jardiner",
    transform: "translate(-263.000000, -500.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(263.000000, 495.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerte",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,1.25 C12.62875,1.25 13.75,2.37125 13.75,3.75 L13.75,11.25 C13.75,12.62875 12.62875,13.75 11.25,13.75 L3.75,13.75 C2.37125,13.75 1.25,12.62875 1.25,11.25 L1.25,3.75 C1.25,2.37125 2.37125,1.25 3.75,1.25 L11.25,1.25 Z M11.25,0 L3.75,0 C1.67875,0 0,1.67875 0,3.75 L0,11.25 C0,13.32125 1.67875,15 3.75,15 L11.25,15 C13.32125,15 15,13.32125 15,11.25 L15,3.75 C15,1.67875 13.32125,0 11.25,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,9.635625 C7.155,9.635625 6.875,9.35625 6.875,9.010625 L6.875,4.21875 C6.875,3.87375 7.155,3.59375 7.5,3.59375 C7.845,3.59375 8.125,3.87375 8.125,4.21875 L8.125,9.010625 C8.125,9.35625 7.845,9.635625 7.5,9.635625 Z",
    id: "_x32__1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,11.40625 C7.33125,11.40625 7.175,11.3375 7.05625,11.225 C7,11.161875 6.95625,11.09375 6.925,11.01875 C6.89375,10.94375 6.875,10.8625 6.875,10.78125 C6.875,10.7 6.89375,10.61875 6.925,10.54375 C6.95625,10.46875 7,10.4 7.05625,10.3375 C7.29375,10.10625 7.7125,10.10625 7.94375,10.3375 C8,10.4 8.04375,10.4625 8.075,10.54375 C8.10625,10.61875 8.125,10.7 8.125,10.78125 C8.125,10.95 8.0625,11.10625 7.94375,11.225 C7.825,11.3375 7.66875,11.40625 7.5,11.40625 L7.5,11.40625 Z",
    id: "_x31_"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d712989abccee13ee76821534b602c9f.svg";
export { ForwardRef as ReactComponent };